import axios from "axios";
import { PATH } from "../../utils";

export const apiGeneralInstance = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

export const authHeaderGeneral = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
